import React, {useState, useEffect} from "react"
import styled from "styled-components"

const Styled ={
    LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    Wrap:styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `,
    BtnWrap:styled.div`
        width:100%;
        height:150px;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: column;
    `,
    Btn:styled.div`
        width:120px;
        height:45px;
        background-color:gold;
        border-radius: 10px;
        display:flex;
        justify-content: center;
        flex-direction:row;
        align-items: center;
        :hover{
            opacity:50%;
        }
    `,
    Fonts:styled.a`
        font-size:30px;
        color:blueviolet;
        font-weight: 500;
        font-family:"Jua", sans-serif;
        :hover{
            color:#000;
        }
        /* color: inherit; */
        /* text-decoration: inherit; */
    `,
}
interface PropsType{
    Points : number;
    setPoints : any;
}
const Result=(props : PropsType)=>{
    const setPoints = props.setPoints
    const Points = props.Points
    return(
      <Styled.Wrap>
          <Styled.LittleTitleFont>
              당신의 점수는 {Points}점이에요!
          </Styled.LittleTitleFont>
          <Styled.BtnWrap>
            <Styled.Fonts href="https://blog.naver.com/ksj200479/222718856883" target='_blank'>
                청약 커트라인 알아보기
            </Styled.Fonts>
            <Styled.Fonts href="https://easylaw.go.kr/CSP/CnpClsMain.laf?popMenu=ov&csmSeq=1112&ccfNo=2&cciNo=2&cnpClsNo=1" target="_blank">
                관련 법령 및 정보
            </Styled.Fonts>
          </Styled.BtnWrap>
      </Styled.Wrap>
    )
}

export default Result